import React from "react"
import CountBox from "./CountBox";
import {RiBillFill} from "react-icons/all";
import {react_intl} from "../../index";
class PaidInvoices extends CountBox{
    icon = <RiBillFill size={27} />
    title = react_intl.formatMessage({id:"client_dashboard.paid"})
    color = "success"
}
export default PaidInvoices